import { render, staticRenderFns } from "./RptPartSkuCatTiendaComponent.vue?vue&type=template&id=f81e8530&"
import script from "./RptPartSkuCatTiendaComponent.vue?vue&type=script&lang=js&"
export * from "./RptPartSkuCatTiendaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports